import { ReactElement } from "react";
import { ContactListItem } from "../../../Items/ContactListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ContactSource } from "client/Api/Email/contacts";
import { generateTrackingId } from "client/Misc/utils";
import { useContactNavigationHandler } from "../../../Navigation/useContactNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type ContactItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Contact>;
	itemIndex: number;
	onRemove: () => void;
	onOpenContactDetails: (id: string, source: ContactSource) => void;
	tabIndex: number;
};

export const ContactItemView = (props: ContactItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		onOpenContactDetails,
		tabIndex
	} = props;

	const {
		id,
		contactSource,
		firstName,
		middleName,
		lastName,
		displayName,
		jobTitle,
		department,
		company,
		emailAddress,
		phoneNumber,
		photoUrl
	} = item.contact;

	const openHandler: () => void = useContactNavigationHandler({
		id,
		contactSource,
		onOpenContactDetails,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("contact-item", `|${contactSource}/${id}`)}
			onClick={openHandler}
		>
			<ContactListItem
				id={id}
				contactSource={contactSource}
				firstName={firstName}
				middleName={middleName}
				lastName={lastName}
				displayName={displayName}
				jobTitle={jobTitle}
				department={department}
				company={company}
				emailAddress={emailAddress}
				phoneNumber={phoneNumber}
				photoUrl={photoUrl}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
ContactItemView.displayName = "ContactItemView";